export interface SettingsContainerState {
  currentPlan?: CurrentPlan;
}

export interface SubcriptionPlan {
  id: string;
  title: string;
  description: string;
  priceMonthly: number;
  priceYearly: number;
  monthPlanId: string;
  yearPlanId: string;
  productId: string;
  currency: string;
  maxSpaceCount: number;
  maxGroupCount: number;
  maxMemberCount: number;
  questionnaireAbility: boolean;
}

export interface CurrentPlan {
  id: string;
  ownerId: string;
  state: number;
  started: string;
  cancelled: string;
  created: string;
  paidUntill: string;
  subscriptionPlan: SubcriptionPlan;
  subscriptionPlanId: string;
  maxSpaceCount: number;
  maxGroupCount: number;
  maxMemberCount: number;
  questionnaireAbility: boolean;
  limitsOverridenUntill: string;
  providerSubscriptionId: string;
  billingUnit: BillingUnit;
}

export enum BillingUnit {
  DAY = 0,
  WEEK = 1,
  MONTH = 2,
  YEAR = 3,
}
